// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"SleepPopup_checkbox__RgX9S","hours":"SleepPopup_hours__2VDtB","info":"SleepPopup_info__3sfZh"};